import React, { createContext, useContext, useEffect, useMemo } from "react";
import { useAuth } from "./auth";
import { ES } from "./translations";

const DICTS = { es: ES };
const Ctx = createContext({ t: (s) => s, lang: "en" });

export const I18nProvider = ({ children }) => {
  const { user } = useAuth();
  const lang = (user?.preferred_language || localStorage.getItem("kz_lang") || "en").toLowerCase();

  useEffect(() => {
    if (user?.preferred_language) localStorage.setItem("kz_lang", user.preferred_language);
  }, [user?.preferred_language]);

  const value = useMemo(() => {
    const dict = DICTS[lang] || null;
    const t = (s) => (dict && dict[s]) || s;
    return { t, lang };
  }, [lang]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useT = () => useContext(Ctx);
